var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003087;}\n\t.st1{fill:#009CDE;}\n\t.st2{fill:#012169;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.4187,40.9816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st0",
    d: "M61.29,159.89c-6.06-6.87-16.84-9.84-30.85-9.84H-9.98c-2.83,0-5.25,2.02-5.66,4.85 l-16.84,106.57c-0.27,2.16,1.35,4.04,3.37,4.04h24.92l6.2-39.74l-0.13,1.21c0.4-2.83,2.83-4.85,5.66-4.85h11.86 c23.31,0,41.5-9.43,46.75-36.78c0.13-0.81,0.27-1.62,0.4-2.43C68.43,172.96,66.82,166.09,61.29,159.89"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.3312,26.8632)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.42,224.78c-1.48,9.97-9.16,9.97-16.57,9.97h-4.18l2.96-18.73c0.13-1.08,1.21-2.02,2.29-2.02h1.89 c4.98,0,9.84,0,12.26,2.83C281.55,218.71,281.96,221.14,281.42,224.78 M278.18,198.64h-27.89c-1.89,0-3.5,1.35-3.77,3.23 l-11.32,71.4c-0.27,1.35,0.81,2.69,2.29,2.69h14.28c1.35,0,2.43-0.94,2.69-2.29l3.23-20.21c0.27-1.89,1.89-3.23,3.77-3.23h8.76 c18.32,0,28.97-8.89,31.66-26.54c1.21-7.68,0-13.74-3.5-17.92C294.49,201.06,287.48,198.64,278.18,198.64"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.0115,26.8632)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.99,224.78c-1.48,9.97-9.16,9.97-16.57,9.97h-4.18l2.96-18.73c0.13-1.08,1.21-2.02,2.29-2.02h1.89 c4.98,0,9.84,0,12.26,2.83C138.12,218.71,138.53,221.14,137.99,224.78 M134.76,198.64h-27.89c-1.89,0-3.5,1.35-3.77,3.23 l-11.32,71.4c-0.27,1.35,0.81,2.69,2.29,2.69h13.34c1.89,0,3.5-1.35,3.77-3.23l3.1-19.27c0.27-1.89,1.89-3.23,3.77-3.23h8.76 c18.32,0,28.97-8.89,31.66-26.54c1.21-7.68,0-13.74-3.5-17.92C151.19,201.06,144.19,198.64,134.76,198.64"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.1228,19.7234)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.33,257.46c-1.35,7.68-7.28,12.8-15.09,12.8c-3.91,0-7.01-1.21-8.89-3.64c-2.02-2.29-2.69-5.66-2.16-9.43 c1.21-7.54,7.41-12.8,14.95-12.8c3.77,0,6.87,1.21,8.89,3.64C182.19,250.45,183,253.82,182.33,257.46 M200.92,231.59h-13.34 c-1.08,0-2.16,0.81-2.29,2.02l-0.54,3.77l-0.94-1.35c-2.83-4.18-9.3-5.66-15.76-5.66c-14.69,0-27.35,11.18-29.77,26.81 c-1.21,7.81,0.54,15.22,4.98,20.48c4.04,4.85,9.84,6.74,16.84,6.74c11.86,0,18.46-7.68,18.46-7.68l-0.54,3.77 c-0.27,1.35,0.81,2.69,2.29,2.69h11.99c1.89,0,3.5-1.35,3.77-3.23l7.28-45.67C203.48,232.8,202.4,231.59,200.92,231.59"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.4426,19.7234)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M325.76,257.46c-1.35,7.68-7.28,12.8-15.09,12.8c-3.91,0-7.01-1.21-8.89-3.64c-2.02-2.29-2.69-5.66-2.16-9.43 c1.21-7.54,7.41-12.8,14.95-12.8c3.77,0,6.87,1.21,8.89,3.64S326.29,253.82,325.76,257.46 M344.35,231.59h-13.34 c-1.08,0-2.16,0.81-2.29,2.02l-0.54,3.77l-0.94-1.35c-2.83-4.18-9.3-5.66-15.76-5.66c-14.69,0-27.35,11.18-29.77,26.81 c-1.21,7.81,0.54,15.22,4.98,20.48c4.04,4.85,9.84,6.74,16.84,6.74c11.86,0,18.46-7.68,18.46-7.68l-0.54,3.77 c-0.27,1.35,0.81,2.69,2.29,2.69h11.99c1.89,0,3.5-1.35,3.77-3.23l7.28-45.67C346.91,232.8,345.83,231.59,344.35,231.59"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.0795,26.9523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M247.04,224.27h-13.47c-1.35,0-2.43,0.67-3.23,1.75l-18.32,27.21l-7.81-26.14 c-0.54-1.62-2.02-2.83-3.77-2.83h-13.2c-1.62,0-2.69,1.62-2.16,3.1l14.82,43.38l-13.88,19.54c-1.08,1.48,0,3.64,1.89,3.64h13.34 c1.21,0,2.43-0.67,3.23-1.62l44.59-64.4C250,226.42,248.93,224.27,247.04,224.27"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.996,33.5807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M350.49,193.83l-11.45,72.75c-0.27,1.35,0.81,2.69,2.29,2.69h11.45c1.89,0,3.5-1.35,3.77-3.23 l11.32-71.4c0.27-1.35-0.81-2.69-2.29-2.69h-12.8C351.71,191.94,350.76,192.75,350.49,193.83"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.4187,40.9816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M61.29,159.89c-6.06-6.87-16.84-9.84-30.85-9.84H-9.98c-2.83,0-5.25,2.02-5.66,4.85 l-16.84,106.57c-0.27,2.16,1.35,4.04,3.37,4.04h24.92l6.2-39.74l-0.13,1.21c0.4-2.83,2.83-4.85,5.66-4.85h11.86 c23.31,0,41.5-9.43,46.75-36.78c0.13-0.81,0.27-1.62,0.4-2.43C68.43,172.96,66.82,166.09,61.29,159.89"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.8489,34.4853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M23.63,189.7c0.27-1.75,1.35-3.1,2.83-3.77c0.67-0.27,1.35-0.54,2.16-0.54h31.53 c3.77,0,7.28,0.27,10.37,0.81c0.94,0.13,1.75,0.27,2.69,0.54c0.81,0.13,1.75,0.4,2.56,0.67c0.4,0.13,0.81,0.27,1.21,0.4 c1.62,0.54,3.1,1.08,4.31,1.89c1.62-10.1,0-16.98-5.52-23.17c-6.06-6.87-16.84-9.84-30.85-9.84H4.5c-2.83,0-5.25,2.02-5.66,4.85 l-16.57,106.43c-0.27,2.16,1.35,4.04,3.37,4.04h24.92l6.2-39.74L23.63,189.7z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.9429,34.5226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st1",
    d: "M65.32,189.58L65.32,189.58c-0.13,0.81-0.27,1.62-0.4,2.43 c-5.25,27.35-23.58,36.78-46.75,36.78H6.31c-2.83,0-5.25,2.02-5.66,4.85l-6.2,38.4l-1.75,10.91c-0.27,1.89,1.08,3.5,2.96,3.5 h21.02c2.43,0,4.58-1.75,4.98-4.31l0.27-1.08L25.85,256l0.27-1.35c0.4-2.43,2.56-4.31,4.98-4.31h3.1 c20.34,0,36.24-8.22,40.96-32.2c1.89-9.97,0.94-18.32-4.18-24.25C69.5,192.14,67.48,190.79,65.32,189.58"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.3922,35.1407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st2",
    d: "M61.28,186.69c-0.81-0.27-1.62-0.4-2.56-0.67c-0.81-0.13-1.75-0.4-2.69-0.54 c-3.23-0.54-6.74-0.81-10.37-0.81H13.99c-0.81,0-1.48,0.13-2.16,0.54c-1.48,0.67-2.56,2.02-2.83,3.77l-6.74,42.57l-0.13,1.21 c0.4-2.83,2.83-4.85,5.66-4.85h11.86c23.31,0,41.5-9.43,46.75-36.78c0.13-0.81,0.27-1.62,0.4-2.43c-1.35-0.67-2.83-1.35-4.31-1.89 C62.09,186.96,61.69,186.83,61.28,186.69"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.e733ddcd4979048ab66b6aaef665635a.svg";
export { ForwardRef as ReactComponent };